export default __webpack_public_path__ + "static/media/bell-btn.a3654f77.svg";